<template>
	<div id="account-user">
		<router-view/>
	</div>
</template>


<script>
	
	export default
	{
		created() {
			this.$vuetify.theme.dark = true
		}
	}
	
</script>